import type {
  BasketWithOptions,
  WishlistWithOptions,
  ProductWith,
} from '@scayle/storefront-nuxt'
import { sustainabilityAttributes } from '../utils/sustainability'
// Brand-specific. `~/` in a layer intentionally resolves to the consuming
// app — see AGENTS.md "Path-Resolution-Cheat-Sheet".
import { DEFAULT_PRICE_PROMOTION_KEY } from '~/config/promotions'

export { DEFAULT_PRICE_PROMOTION_KEY }

export const WISHLIST_WITH: WishlistWithOptions = {
  items: {
    variant: {
      attributes: {
        withKey: [
          'sizeCategory',
          'sizeCategorySize',
          'price',
          'size',
          'erpSizeKey',
          'restockDate',
        ],
      },
      lowestPriorPrice: true,
    },
    product: {
      attributes: {
        withKey: ['color', 'brand', 'name', 'mainOrderNumberList', 'sizeNote'],
      },
      advancedAttributes: {
        withKey: ['mainOrderNumber'],
      },
      categories: 'all',
      variants: {
        attributes: {
          withKey: [
            'sizeCategory',
            'sizeCategorySize',
            'price',
            'size',
            'erpSizeKey',
          ],
        },
        lowestPriorPrice: true,
      },
      images: {
        attributes: {
          withKey: ['imageType', 'imageView', 'imageBackground', 'imageKind'],
        },
      },
      priceRange: true,
      lowestPriorPrice: true,
    },
  },
  pricePromotionKey: DEFAULT_PRICE_PROMOTION_KEY,
}

export const BASKET_WITH: BasketWithOptions = WISHLIST_WITH

export const DEFAULT_PRODUCT_WITH: ProductWith = {
  attributes: {
    withKey: [
      'colorRange',
      'colorHex',
      'color',
      'brand',
      'name',
      ...sustainabilityAttributes,
      'premiumsegment',
      'einfuehrungsgrund',
      // ECOM-2639: needed so the client-side directOrder guard can evaluate
      // products on both the Scayle listing path (via PRODUCT_LISTING_WITH)
      // and the Odoscope-hydrated path (getProductsByIdsParallel).
      'directOrder',
    ],
  },
  variants: {
    attributes: {
      withKey: ['price', 'sizeCategory'],
    },
    lowestPriorPrice: true,
  },
  siblings: {
    attributes: {
      withKey: ['colorRange', 'colorHex', 'color', 'brand', 'name'],
    },
  },
  images: {
    attributes: {
      withKey: [
        'assetType',
        'imageType',
        'imageView',
        'imageBackground',
        'imageKind',
      ],
    },
  },
  priceRange: true,
  categories: {
    properties: {
      withName: ['baseCategories'],
    },
  },
  lowestPriorPrice: true,
}

export const PRODUCT_LISTING_WITH = {
  ...DEFAULT_PRODUCT_WITH,
  siblings: {
    attributes: {
      withKey: ['colorRange', 'colorHex', 'color', 'directOrder'],
    },
    images: {},
  },
}
